import React from 'react';
import { Typography } from '@mui/material';

// Assets
import leftArrow from '@/assets/icons/arrow-left.svg';
import rightArrow from '@/assets/icons/arrow-right.svg';
import doubleLeftArrow from '@/assets/icons/arrow-left-end.svg';
import doubleRightArrow from '@/assets/icons/arrow-right-end.svg';

type PaginationProps = {
  totalItems: number;
  rowsPerPage: number;
  currentPage: number;
  onPageChange: (newPage: number) => void;
};

const Pagination: React.FC<PaginationProps> = ({
  totalItems,
  rowsPerPage,
  currentPage,
  onPageChange,
}) => {
  const totalPages = Math.ceil(totalItems / rowsPerPage);
  const pageNumbers = [];

  let startPage = Math.max(0, currentPage - 1);
  let endPage = Math.min(totalPages - 1, currentPage + 1);

  if (currentPage === 0) {
    endPage = Math.min(totalPages - 1, 2);
  } else if (currentPage === totalPages - 1) {
    startPage = Math.max(0, totalPages - 3);
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  return (
    <div className="pagination_wrapper" data-testid="pagination">
      <div>
        <Typography className="content">
          {`Showing results ${(currentPage * rowsPerPage + 1).toLocaleString()} - ${Math.min(
            (currentPage + 1) * rowsPerPage,
            totalItems,
          ).toLocaleString()} of ${totalItems.toLocaleString()}`}
        </Typography>
      </div>
      <div className="pagination-btn-container">
        <button
          onClick={() => onPageChange(0)}
          disabled={currentPage === 0}
          className="left-arrows"
        >
          <img src={doubleLeftArrow} alt="double-left-arrow" />
        </button>
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 0}
          className="left-arrows"
        >
          <img src={leftArrow} alt="left-arrow" />
        </button>
        <div className="pagination-number_wrap">
          {pageNumbers.map((page) => (
            <div
              key={page}
              onClick={() => onPageChange(page)}
              className={`pagination-page ${currentPage === page ? 'active-page' : ''}`}
            >
              <Typography className="pagination-number">{page + 1}</Typography>
            </div>
          ))}
        </div>

        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage + 1 >= totalPages}
          className="right-arrows"
        >
          <img src={rightArrow} alt="right-arrow" />
        </button>
        <button
          onClick={() => onPageChange(totalPages - 1)}
          disabled={currentPage + 1 >= totalPages}
          className="right-arrows"
        >
          <img src={doubleRightArrow} alt="double-right-arrow" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
